import { createContext, Dispatch, SetStateAction } from 'react';

import { TenantUserProfile } from './types/TenantUserProfile';

interface TenantAuthContextType {
  profile: TenantUserProfile | undefined;
  setProfile: Dispatch<SetStateAction<TenantUserProfile | undefined>>;
}

export const TenantAuthContext = createContext<TenantAuthContextType | undefined>(undefined);
